import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import isDesktop from "../isDesktop";
import RoleTabsSelect from "./RoleTabsSelect";
const AddRoleDialog = ({
  isOpen,
  onClose,
  onSave,
  onTabToggle,
  selectedTabs,
  newRole,
  setNewRole,
  tabs = [],
  tabsLoading = false,
}) => {
  const isDesktopDevice = isDesktop();

  return (
    <Dialog open={isOpen} onClose={onClose}>
      <DialogTitle style={{ fontWeight: "600" }}>Add Role</DialogTitle>
      <DialogContent style={{ width: !isDesktopDevice && "80vw" }}>
        <TextField
          label="Role"
          className="mt-2"
          value={newRole.roleName}
          onChange={(e) => setNewRole({ ...newRole, roleName: e.target.value })}
          fullWidth
          sx={{
            "& .MuiOutlinedInput-root": {
              "& fieldset": {
                borderColor: "transparent",
              },
              "&:hover fieldset": {
                borderColor: "transparent",
              },
              "&.Mui-focused fieldset": {
                borderColor: "transparent",
                boxShadow: "none",
              },
            },
          }}
          InputProps={{
            style: {
              boxShadow:
                "0px 1.74px 3.48px 0px #0000001A inset, 0px -1.74px 3.8px 0px #C8C7C740 inset, 0px 1.74px 3.48px 0px #0000001A",
            },
          }}
          InputLabelProps={{
            sx: { "&.Mui-focused": { color: "#A8A8A8" } },
            required: false,
          }}
        />
        <p
          style={{
            display: "flex",
            alignItems: "center",
            paddingLeft: "14px",
            width: isDesktopDevice && "500px",
            height: "36px",
            boxShadow: "2px 2px 4px 0px #AEAEC080",
            background: "#EAF1F7",
            marginTop: "20px",
            marginBottom: "8px",
          }}
        >
          Tabs
        </p>
        <RoleTabsSelect
          selectedTabs={selectedTabs}
          tabs={tabs}
          tabsLoading={tabsLoading}
          onTabToggle={onTabToggle}
        />
      </DialogContent>
      <DialogActions style={{ margin: "auto", padding: "18px" }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Button
            onClick={onClose}
            style={{
              width: isDesktopDevice && "15vw",
              minWidth: !isDesktopDevice && "32vw",
              border: "2px solid #37446F",
              background: "none",
              height: isDesktopDevice ? "2.564vw" : "2.25rem",
              color: "black",
              textTransform: "none",
              marginRight: "10px",
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={onSave}
            style={{
              width: isDesktopDevice && "15vw",
              minWidth: !isDesktopDevice && "32vw",
              background: "#37446F",
              height: isDesktopDevice ? "2.564vw" : "2.25rem",
              color: "white",
              textTransform: "none",
            }}
          >
            Save
          </Button>
        </div>
      </DialogActions>
    </Dialog>
  );
};

export default AddRoleDialog;
